export const FormatMoney = (number, symbol = null) => {
    number = !number ? 0.00 : number;
    if (symbol === "NGN") {
        return '₦' + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
    }if (symbol ===  "USD"){
        return '$' + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
    } if(symbol === "EUR"){
        return '€' + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
    }if(symbol === "GBP"){
        return '£' + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
    } else {
        return getCurrency() + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
    }

}
export const getCurrency = () => {
    const settings = localStorage.getItem("invoiceSetting");
    if (settings !== null) {
        const currency = JSON.parse(settings);
        if (currency.symbol) {
            return currency.symbol;
        } else {
            return '₦';
        }
        return currency.symbol ? currency.symbol : 'N';
    } else {
        return '₦';
    }
}
export const FormatDollar = (number, symbol = "$") => {
    number = !number ? 0.00 : number;
    return symbol + (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
export const FormatMoneyWithoutCurrency = (number, symbol = null) => {
    number = !number ? 0.00 : number;
    return (parseFloat(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
}